module["exports"] = ["შპს", "სს", "ააიპ", "სსიპ"];